import React, { useState } from 'react';
import { ChevronLeftIcon } from 'lucide-react';
import { FormField } from '../../common/FormField';
interface Props {
  type: string;
  onBack: () => void;
  onSubmit: (data: any) => void;
  isSubmitting: boolean;
}
export const CustomApiForm = ({
  type,
  onBack,
  onSubmit,
  isSubmitting
}: Props) => {
  const [formData, setFormData] = useState({
    name: '',
    url: '',
    authType: 'bearer',
    apiKey: '',
    username: '',
    password: '',
    headers: '',
    description: ''
  });
  const [errors, setErrors] = useState<Record<string, string>>({});
  const validateForm = () => {
    const newErrors: Record<string, string> = {};
    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
    }
    if (!formData.url.trim()) {
      newErrors.url = 'URL is required';
    } else {
      try {
        new URL(formData.url);
      } catch {
        newErrors.url = 'Invalid URL format';
      }
    }
    if (formData.authType === 'bearer' && !formData.apiKey.trim()) {
      newErrors.apiKey = 'API key is required';
    }
    if (formData.authType === 'basic' && (!formData.username.trim() || !formData.password.trim())) {
      newErrors.username = 'Username and password are required';
    }
    if (formData.headers) {
      try {
        JSON.parse(formData.headers);
      } catch {
        newErrors.headers = 'Invalid JSON format';
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validateForm()) {
      onSubmit(formData);
    }
  };
  return <form onSubmit={handleSubmit} className="space-y-6" data-id="element-677">
      <button type="button" onClick={onBack} className="flex items-center gap-2 text-sm text-gray-400 hover:text-gray-300 mb-4" data-id="element-678">
        <ChevronLeftIcon size={16} data-id="element-679" />
        Back to integration types
      </button>
      <FormField label="Connection Name" type="text" value={formData.name} onChange={value => setFormData(prev => ({
      ...prev,
      name: value
    }))} error={errors.name} required tooltip="A unique name for this API connection" data-id="element-680" />
      <FormField label="API Endpoint URL" type="url" value={formData.url} onChange={value => setFormData(prev => ({
      ...prev,
      url: value
    }))} error={errors.url} required tooltip="The base URL of the API endpoint" data-id="element-681" />
      <FormField label="Authentication Type" type="select" value={formData.authType} onChange={value => setFormData(prev => ({
      ...prev,
      authType: value
    }))} options={[{
      value: 'bearer',
      label: 'Bearer Token'
    }, {
      value: 'basic',
      label: 'Basic Auth'
    }, {
      value: 'none',
      label: 'No Auth'
    }]} tooltip="Choose how to authenticate with the API" data-id="element-682" />
      {formData.authType === 'bearer' && <FormField label="API Key" type="password" value={formData.apiKey} onChange={value => setFormData(prev => ({
      ...prev,
      apiKey: value
    }))} error={errors.apiKey} required tooltip="Your API key or bearer token" data-id="element-683" />}
      {formData.authType === 'basic' && <div className="grid grid-cols-2 gap-4" data-id="element-684">
          <FormField label="Username" type="text" value={formData.username} onChange={value => setFormData(prev => ({
        ...prev,
        username: value
      }))} error={errors.username} required data-id="element-685" />
          <FormField label="Password" type="password" value={formData.password} onChange={value => setFormData(prev => ({
        ...prev,
        password: value
      }))} error={errors.password} required data-id="element-686" />
        </div>}
      <FormField label="Custom Headers" type="textarea" value={formData.headers} onChange={value => setFormData(prev => ({
      ...prev,
      headers: value
    }))} error={errors.headers} tooltip="Additional headers in JSON format" placeholder='{"X-Custom-Header": "value"}' data-id="element-687" />
      <FormField label="Description" type="textarea" value={formData.description} onChange={value => setFormData(prev => ({
      ...prev,
      description: value
    }))} tooltip="Optional description of this API connection" data-id="element-688" />
      <div className="flex justify-end gap-3 pt-6" data-id="element-689">
        <button type="button" onClick={onBack} className="px-4 py-2 text-sm text-gray-400 hover:text-gray-300 transition-colors" disabled={isSubmitting} data-id="element-690">
          Cancel
        </button>
        <button type="submit" disabled={isSubmitting} className="px-6 py-2 bg-accent hover:bg-accent-light text-white rounded-none transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2" data-id="element-691">
          {isSubmitting ? <>
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" data-id="element-692" />
              Connecting...
            </> : 'Connect API'}
        </button>
      </div>
    </form>;
};